import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import FeedIcon from '@mui/icons-material/Feed';
import DeleteIcon from '@mui/icons-material/Delete';
import MainCard from './MainCard';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';



const StickyHeadOneButtonTable = ({ rows, columns, handleDetail, title, handleDownload, handleDelete }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <MainCard title={title}>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={{ minWidth: column.minWidth, bgcolor: "#406599", color:"white" }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                let uuid = row.token;
                if (row.data !== undefined) {
                  uuid = row.data
                }
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.token}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                        {typeof value === 'boolean'?
                          (value === false ? 'False':'True'):
                          (column.action?
                            (<div><Button onClick={() => handleDetail(uuid)}><FeedIcon sx={{ color: "#406599",fontSize: 20 }}/></Button></div>):
                            (column.download?(<div><Button onClick={() => handleDownload(uuid)}><CloudDownloadIcon sx={{ color: "#406599",fontSize: 20 }}/></Button></div>):
                              (column.delete?(<div><Button onClick={() => handleDelete(uuid)}><DeleteIcon sx={{ color: "#406599",fontSize: 20 }}/></Button></div>):(value))))}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ bgcolor: "#406599", color:"white" }}
      />
    </Paper>
    </MainCard>
  );
}

export default StickyHeadOneButtonTable;
